import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class RestoreFromIsolationActionValidator extends BaseNetworkActionValidator {
  protected canRunForMultipleItems = false;

  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    return ProtectedEntitiesHelper.isUnifiedClient(record);
  }
}
